__webpack_require__.p = "/risebinar/_next/";